var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6896 3.85675C17.4094 2.32324 19.5906 2.32324 20.3104 3.85675L23.609 10.8836C23.8922 11.4868 24.4571 11.9093 25.1156 12.0105L32.6554 13.1694C34.2639 13.4166 34.9195 15.379 33.7826 16.5434L28.2055 22.2554C27.7618 22.7098 27.5603 23.3478 27.6626 23.9746L28.9609 31.9344C29.2296 33.5822 27.4802 34.8145 26.0191 34.0065L19.4678 30.3838C18.8656 30.0507 18.1344 30.0507 17.5322 30.3838L10.9809 34.0065C9.51977 34.8145 7.77036 33.5822 8.03914 31.9344L9.33744 23.9746C9.43967 23.3478 9.23817 22.7098 8.79453 22.2554L3.21739 16.5434C2.08048 15.379 2.73608 13.4166 4.34457 13.1694L11.8844 12.0105C12.5429 11.9093 13.1078 11.4868 13.391 10.8836L16.6896 3.85675Z",
    stroke: "#EC4C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.e66fba99a6462a71bb30896cfffa2521.svg";
export { ForwardRef as ReactComponent };